import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthActionsService {
  private _changePasswordCounter = signal(0);
  readonly changePasswordTrigger = this._changePasswordCounter.asReadonly();

  requestChangePassword() {
    this._changePasswordCounter.update(n => n + 1);
  }
}